module.exports = __webpack_public_path__ + "img/cover-outer-cropped.132dea77.png";